import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './trip.actions';
import * as tripQuery from './trip.selectors';

@Injectable()
export class TripFacade {
  deletedScheduledAircraftTripSkeletonsLoading$ = this.store.pipe(
    select(tripQuery.getDeletedScheduledTripSkeletonsLoading)
  );
  deletedScheduledAircraftTripSkeletonsLoaded$ = this.store.pipe(
    select(tripQuery.getDeletedScheduledTripSkeletonsLoaded)
  );
  deletedScheduledAircraftTripSkeletons$ = this.store.pipe(
    select(tripQuery.getDeletedScheduledTripSkeletons)
  );

  scheduledAircraftTripSkeletonLoading$ = this.store.pipe(
    select(tripQuery.getScheduledAircraftTripSkeletonLoading)
  );
  scheduledAircraftTripSkeletonLoaded$ = this.store.pipe(
    select(tripQuery.getScheduledAircraftTripSkeletonLoaded)
  );
  scheduledAircraftTripSkeleton$ = this.store.pipe(
    select(tripQuery.getScheduledAircraftTripSkeleton)
  );

  scheduledAircraftTripAuditLoading$ = this.store.pipe(
    select(tripQuery.getScheduledAircraftTripAuditLoading)
  );
  scheduledAircraftTripAuditLoaded$ = this.store.pipe(
    select(tripQuery.getScheduledAircraftTripAuditLoaded)
  );
  scheduledAircraftTripAudit$ = this.store.pipe(select(tripQuery.getScheduledAircraftTripAudits));

  scheduledFlightAuditLoading$ = this.store.pipe(select(tripQuery.getScheduledFlightAuditLoading));
  scheduledFlightAuditLoaded$ = this.store.pipe(select(tripQuery.getScheduledFlightAuditLoaded));
  scheduledFlightAudit$ = this.store.pipe(select(tripQuery.getScheduledFlightAudits));

  flightAuditLoading$ = this.store.pipe(select(tripQuery.getFlightAuditLoading));
  flightAuditLoaded$ = this.store.pipe(select(tripQuery.getFlightAuditLoaded));
  flightAudits$ = this.store.pipe(select(tripQuery.getFlightAudits));

  flightPassengerAuditLoading$ = this.store.pipe(select(tripQuery.getFlightPassengerAuditLoading));
  flightPassengerAuditLoaded$ = this.store.pipe(select(tripQuery.getFlightPassengerAuditLoaded));
  flightPassengerAudit$ = this.store.pipe(select(tripQuery.getFlightPassengerAudits));

  flightPassengerCateringAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightPassengerCateringAuditLoading)
  );
  flightPassengerCateringAuditLoaded$ = this.store.pipe(
    select(tripQuery.getFlightPassengerCateringAuditLoaded)
  );
  flightPassengerCateringAudit$ = this.store.pipe(
    select(tripQuery.getFlightPassengerCateringAudits)
  );

  flightPassengerHotelAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightPassengerHotelAuditLoading)
  );
  flightPassengerHotelAuditLoaded$ = this.store.pipe(
    select(tripQuery.getFlightPassengerHotelAuditLoaded)
  );
  flightPassengerHotelAudit$ = this.store.pipe(select(tripQuery.getFlightPassengerHotelAudits));

  flightPassengerTransportationAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightPassengerTransportationAuditLoading)
  );
  flightPassengerTransportationAuditLoaded$ = this.store.pipe(
    select(tripQuery.getFlightPassengerTransportationAuditLoaded)
  );
  flightPassengerTransportationAudit$ = this.store.pipe(
    select(tripQuery.getFlightPassengerTransportationAudits)
  );

  flightCrewMemberAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberAuditLoading)
  );
  flightCrewMemberAuditLoaded$ = this.store.pipe(select(tripQuery.getFlightCrewMemberAuditLoaded));
  flightCrewMemberAudits$ = this.store.pipe(select(tripQuery.getFlightCrewMemberAudits));

  flightCrewMemberCateringAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberCateringAuditLoading)
  );
  flightCrewMemberCateringAuditLoaded$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberCateringAuditLoaded)
  );
  flightCrewMemberCateringAudit$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberCateringAudits)
  );

  flightCrewMemberHotelAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberHotelAuditLoading)
  );
  flightCrewMemberHotelAuditLoaded$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberHotelAuditLoaded)
  );
  flightCrewMemberHotelAudit$ = this.store.pipe(select(tripQuery.getFlightCrewMemberHotelAudits));

  flightCrewMemberTransportationAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberTransportationAuditLoading)
  );
  flightCrewMemberTransportationAuditLoaded$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberTransportationAuditLoaded)
  );
  flightCrewMemberTransportationAudit$ = this.store.pipe(
    select(tripQuery.getFlightCrewMemberTransportationAudits)
  );

  flightBusinessPersonAuditLoading$ = this.store.pipe(
    select(tripQuery.getFlightBusinessPersonAuditLoading)
  );
  flightBusinessPersonAuditLoaded$ = this.store.pipe(
    select(tripQuery.getFlightBusinessPersonAuditLoaded)
  );
  flightBusinessPersonAudits$ = this.store.pipe(select(tripQuery.getFlightBusinessPersonAudits));

  scheduledEventAuditLoaded$ = this.store.pipe(select(tripQuery.getScheduledEventAuditLoaded));
  scheduledEventAuditLoading$ = this.store.pipe(select(tripQuery.getScheduledEventAuditLoading));
  scheduledEventAudits$ = this.store.pipe(select(tripQuery.getScheduledEventAudits));

  legNoteAuditLoaded$ = this.store.pipe(select(tripQuery.getLegNoteAuditLoaded));
  legNoteAuditLoading$ = this.store.pipe(select(tripQuery.getLegNoteAuditLoading));
  legNoteAudits$ = this.store.pipe(select(tripQuery.getLegNoteAudits));

  flightFuelAuditLoading$ = this.store.pipe(select(tripQuery.getFlightFuelAuditLoading));
  flightFuelAuditLoaded$ = this.store.pipe(select(tripQuery.getFlightFuelAuditLoaded));
  flightFuelAudit$ = this.store.pipe(select(tripQuery.getFlightFuelAudits));

  // V2 Observables for lazy loading
  deletedTripsLoading$ = this.store.pipe(select(tripQuery.getDeletedTripsLoading));
  deletedTripsLoaded$ = this.store.pipe(select(tripQuery.getDeletedTripsLoaded));
  deletedTrips$ = this.store.pipe(select(tripQuery.getDeletedTrips));

  tripLogsLoading$ = this.store.pipe(select(tripQuery.getTripLogsLoading));
  tripLogsLoaded$ = this.store.pipe(select(tripQuery.getTripLogsLoaded));
  tripLogs$ = this.store.pipe(select(tripQuery.getTripLogs));
  tripLogsHasMore$ = this.store.pipe(select(tripQuery.getTripLogsHasMore));

  deletedTripLegsLoading$ = this.store.pipe(select(tripQuery.getDeletedTripLegsLoading));
  deletedTripLegsLoaded$ = this.store.pipe(select(tripQuery.getDeletedTripLegsLoaded));
  deletedTripLegs$ = this.store.pipe(select(tripQuery.getDeletedTripLegs));
  deletedTripLegsHasMore$ = this.store.pipe(select(tripQuery.getDeletedTripLegsHasMore));

  tripLegsLoading$ = this.store.pipe(select(tripQuery.getTripLegsLoading));
  tripLegsLoaded$ = this.store.pipe(select(tripQuery.getTripLegsLoaded));
  tripLegs$ = this.store.pipe(select(tripQuery.getTripLegs));
  tripLegsHasMore$ = this.store.pipe(select(tripQuery.getTripLegsHasMore));

  legEventLogsLoading$ = this.store.pipe(select(tripQuery.getLegEventLogsLoading));
  legEventLogsLoaded$ = this.store.pipe(select(tripQuery.getLegEventLogsLoaded));
  legEventLogs$ = this.store.pipe(select(tripQuery.getLegEventLogs));
  legEventLogsHasMore$ = this.store.pipe(select(tripQuery.getLegEventLogsHasMore));

  legFlightLogsLoading$ = this.store.pipe(select(tripQuery.getLegFlightLogsLoading));
  legFlightLogsLoaded$ = this.store.pipe(select(tripQuery.getLegFlightLogsLoaded));
  legFlightLogs$ = this.store.pipe(select(tripQuery.getLegFlightLogs));
  legFlightLogsHasMore$ = this.store.pipe(select(tripQuery.getLegFlightLogsHasMore));

  legFuelLogsLoading$ = this.store.pipe(select(tripQuery.getLegFuelLogsLoading));
  legFuelLogsLoaded$ = this.store.pipe(select(tripQuery.getLegFuelLogsLoaded));
  legFuelLogs$ = this.store.pipe(select(tripQuery.getLegFuelLogs));
  legFuelLogsHasMore$ = this.store.pipe(select(tripQuery.getLegFuelLogsHasMore));

  flightCrewMembersLoading$ = this.store.pipe(select(tripQuery.getFlightCrewMembersLoading));
  flightCrewMembersLoaded$ = this.store.pipe(select(tripQuery.getFlightCrewMembersLoaded));
  flightCrewMembers$ = this.store.pipe(select(tripQuery.getFlightCrewMembers));
  flightCrewMembersHasMore$ = this.store.pipe(select(tripQuery.getFlightCrewMembersHasMore));

  crewLogsLoading$ = this.store.pipe(select(tripQuery.getCrewLogsLoading));
  crewLogsLoaded$ = this.store.pipe(select(tripQuery.getCrewLogsLoaded));
  crewLogs$ = this.store.pipe(select(tripQuery.getCrewLogs));
  crewLogsHasMore$ = this.store.pipe(select(tripQuery.getCrewLogsHasMore));

  crewCateringLogsLoading$ = this.store.pipe(select(tripQuery.getCrewCateringLogsLoading));
  crewCateringLogsLoaded$ = this.store.pipe(select(tripQuery.getCrewCateringLogsLoaded));
  crewCateringLogs$ = this.store.pipe(select(tripQuery.getCrewCateringLogs));
  crewCateringLogsHasMore$ = this.store.pipe(select(tripQuery.getCrewCateringLogsHasMore));

  crewHotelLogsLoading$ = this.store.pipe(select(tripQuery.getCrewHotelLogsLoading));
  crewHotelLogsLoaded$ = this.store.pipe(select(tripQuery.getCrewHotelLogsLoaded));
  crewHotelLogs$ = this.store.pipe(select(tripQuery.getCrewHotelLogs));
  crewHotelLogsHasMore$ = this.store.pipe(select(tripQuery.getCrewHotelLogsHasMore));

  crewTransportationLogsLoading$ = this.store.pipe(select(tripQuery.getCrewTransportationLogsLoading));
  crewTransportationLogsLoaded$ = this.store.pipe(select(tripQuery.getCrewTransportationLogsLoaded));
  crewTransportationLogs$ = this.store.pipe(select(tripQuery.getCrewTransportationLogs));
  crewTransportationLogsHasMore$ = this.store.pipe(select(tripQuery.getCrewTransportationLogsHasMore));

  flightPassengersLoading$ = this.store.pipe(select(tripQuery.getFlightPassengersLoading));
  flightPassengersLoaded$ = this.store.pipe(select(tripQuery.getFlightPassengersLoaded));
  flightPassengers$ = this.store.pipe(select(tripQuery.getFlightPassengers));
  flightPassengersHasMore$ = this.store.pipe(select(tripQuery.getFlightPassengersHasMore));

  passengerLogsLoading$ = this.store.pipe(select(tripQuery.getPassengerLogsLoading));
  passengerLogsLoaded$ = this.store.pipe(select(tripQuery.getPassengerLogsLoaded));
  passengerLogs$ = this.store.pipe(select(tripQuery.getPassengerLogs));
  passengerLogsHasMore$ = this.store.pipe(select(tripQuery.getPassengerLogsHasMore));

  passengerCateringLogsLoading$ = this.store.pipe(select(tripQuery.getPassengerCateringLogsLoading));
  passengerCateringLogsLoaded$ = this.store.pipe(select(tripQuery.getPassengerCateringLogsLoaded));
  passengerCateringLogs$ = this.store.pipe(select(tripQuery.getPassengerCateringLogs));
  passengerCateringLogsHasMore$ = this.store.pipe(select(tripQuery.getPassengerCateringLogsHasMore));

  passengerHotelLogsLoading$ = this.store.pipe(select(tripQuery.getPassengerHotelLogsLoading));
  passengerHotelLogsLoaded$ = this.store.pipe(select(tripQuery.getPassengerHotelLogsLoaded));
  passengerHotelLogs$ = this.store.pipe(select(tripQuery.getPassengerHotelLogs));
  passengerHotelLogsHasMore$ = this.store.pipe(select(tripQuery.getPassengerHotelLogsHasMore));

  passengerTransportationLogsLoading$ = this.store.pipe(select(tripQuery.getPassengerTransportationLogsLoading));
  passengerTransportationLogsLoaded$ = this.store.pipe(select(tripQuery.getPassengerTransportationLogsLoaded));
  passengerTransportationLogs$ = this.store.pipe(select(tripQuery.getPassengerTransportationLogs));
  passengerTransportationLogsHasMore$ = this.store.pipe(select(tripQuery.getPassengerTransportationLogsHasMore));

  flightSchedulersLoading$ = this.store.pipe(select(tripQuery.getFlightSchedulersLoading));
  flightSchedulersLoaded$ = this.store.pipe(select(tripQuery.getFlightSchedulersLoaded));
  flightSchedulers$ = this.store.pipe(select(tripQuery.getFlightSchedulers));
  flightSchedulersHasMore$ = this.store.pipe(select(tripQuery.getFlightSchedulersHasMore));

  schedulerLogsLoading$ = this.store.pipe(select(tripQuery.getSchedulerLogsLoading));
  schedulerLogsLoaded$ = this.store.pipe(select(tripQuery.getSchedulerLogsLoaded));
  schedulerLogs$ = this.store.pipe(select(tripQuery.getSchedulerLogs));
  schedulerLogsHasMore$ = this.store.pipe(select(tripQuery.getSchedulerLogsHasMore));

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadDeletedScheduledAircraftTripSkeletons() {
    this.store.dispatch(actions.ResetDeletedScheduledTrip());
    this.store.dispatch(actions.LoadDeletedScheduledAircraftTripSkeletons());
  }

  nextDeletedScheduledAircraftTripSkeletonsPage() {
    this.store.dispatch(actions.LoadNextPageDeletedScheduledAircraftTripSkeletons());
  }

  loadScheduledAircraftTripSkeleton() {
    this.store.dispatch(actions.LoadScheduledAircraftTripSkeleton());
    this.scheduledAircraftTripSkeleton$.subscribe(skeleton => {
      if (skeleton) {
        this.store.dispatch(
          actions.LoadScheduledAircraftTripAudit({
            scheduledAircraftTripId: skeleton.scheduledAircraftTripId
          })
        );
      }
    });
  }

  loadScheduledTripV2Data() {
    this.store.dispatch(actions.LoadScheduledTripV2Data());
  }

  loadScheduledAircraftTripAudit(scheduledAircraftTripId: number) {
    this.store.dispatch(actions.LoadScheduledAircraftTripAudit({ scheduledAircraftTripId }));
  }

  nextScheduledAircraftTripAuditPage(scheduledAircraftTripId: number) {
    this.store.dispatch(
      actions.LoadNextPageScheduledAircraftTripAudit({ scheduledAircraftTripId })
    );
  }

  loadScheduledFlightAudit(scheduledFlightId: number) {
    this.store.dispatch(actions.LoadScheduledFlightAudit({ scheduledFlightId }));
  }

  nextScheduledFlightAuditPage(scheduledFlightId: number) {
    this.store.dispatch(actions.LoadNextPageScheduledFlightAudit({ scheduledFlightId }));
  }

  loadFlightAudit(flightId: number) {
    this.store.dispatch(actions.LoadFlightAudit({ flightId }));
  }

  nextFlightAuditPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageFlightAudit({ flightId }));
  }

  loadFlightPassengerAudit(flightPassengerId: number) {
    this.store.dispatch(actions.LoadFlightPassengerAudit({ flightPassengerId }));
  }

  nextFlightPassengerAuditPage(flightPassengerId: number) {
    this.store.dispatch(actions.LoadNextPageFlightPassengerAudit({ flightPassengerId }));
  }

  loadFlightPassengerCateringAudit(flightPassengerCateringId: number) {
    this.store.dispatch(actions.LoadFlightPassengerCateringAudit({ flightPassengerCateringId }));
  }

  nextFlightPassengerCateringAuditPage(flightPassengerCateringId: number) {
    this.store.dispatch(
      actions.LoadNextPageFlightPassengerCateringAudit({ flightPassengerCateringId })
    );
  }

  loadFlightPassengerHotelAudit(flightPassengerHotelId: number) {
    this.store.dispatch(actions.LoadFlightPassengerHotelAudit({ flightPassengerHotelId }));
  }

  nextFlightPassengerHotelAuditPage(flightPassengerHotelId: number) {
    this.store.dispatch(actions.LoadNextPageFlightPassengerHotelAudit({ flightPassengerHotelId }));
  }

  loadFlightPassengerTransportationAudit(flightPassengerTransportationId: number) {
    this.store.dispatch(
      actions.LoadFlightPassengerTransportationAudit({ flightPassengerTransportationId })
    );
  }

  nextFlightPassengerTransportationAuditPage(flightPassengerTransportationId: number) {
    this.store.dispatch(
      actions.LoadNextPageFlightPassengerTransportationAudit({ flightPassengerTransportationId })
    );
  }

  loadFlightCrewMemberAudit(flightCrewMemberId: number) {
    this.store.dispatch(actions.LoadFlightCrewMemberAudit({ flightCrewMemberId }));
  }

  nextFlightCrewMemberAuditPage(flightCrewMemberId: number) {
    this.store.dispatch(actions.LoadNextPageFlightCrewMemberAudit({ flightCrewMemberId }));
  }

  loadFlightCrewMemberCateringAudit(flightCrewMemberCateringId: number) {
    this.store.dispatch(actions.LoadFlightCrewMemberCateringAudit({ flightCrewMemberCateringId }));
  }

  nextFlightCrewMemberCateringAuditPage(flightCrewMemberCateringId: number) {
    this.store.dispatch(
      actions.LoadNextPageFlightCrewMemberCateringAudit({ flightCrewMemberCateringId })
    );
  }

  loadFlightCrewMemberHotelAudit(flightCrewMemberHotelId: number) {
    this.store.dispatch(actions.LoadFlightCrewMemberHotelAudit({ flightCrewMemberHotelId }));
  }

  nextFlightCrewMemberHotelAuditPage(flightCrewMemberHotelId: number) {
    this.store.dispatch(
      actions.LoadNextPageFlightCrewMemberHotelAudit({ flightCrewMemberHotelId })
    );
  }

  loadFlightCrewMemberTransportationAudit(flightCrewMemberTransportationId: number) {
    this.store.dispatch(
      actions.LoadFlightCrewMemberTransportationAudit({ flightCrewMemberTransportationId })
    );
  }

  nextFlightCrewMemberTransportationAuditPage(flightCrewMemberTransportationId: number) {
    this.store.dispatch(
      actions.LoadNextPageFlightCrewMemberTransportationAudit({ flightCrewMemberTransportationId })
    );
  }

  loadFlightBusinessPersonAudit(flightBusinessPersonId: number) {
    this.store.dispatch(actions.LoadFlightBusinessPersonAudit({ flightBusinessPersonId }));
  }

  nextFlightBusinessPersonAuditPage(flightBusinessPersonId: number) {
    this.store.dispatch(actions.LoadNextPageFlightBusinessPersonAudit({ flightBusinessPersonId }));
  }

  loadScheduledEventAudit(scheduledEventId: number) {
    this.store.dispatch(actions.LoadScheduledEventAudit({ scheduledEventId }));
  }

  nextScheduledEventAuditPage(scheduledEventId: number) {
    this.store.dispatch(actions.LoadNextPageScheduledEventAudit({ scheduledEventId }));
  }

  loadLegNoteAudit(legNoteId: number) {
    this.store.dispatch(actions.LoadLegNoteAudit({ legNoteId }));
  }

  nextLegNoteAuditPage(legNoteId: number) {
    this.store.dispatch(actions.LoadNextPageLegNoteAudit({ legNoteId }));
  }

  loadFlightFuelAudit(flightFuelId: number) {
    this.store.dispatch(actions.LoadFlightFuelAudit({ flightFuelId }));
  }

  nextFlightFuelAuditPage(flightFuelId: number) {
    this.store.dispatch(actions.LoadNextPageFlightFuelAudit({ flightFuelId }));
  }

  // V2 Methods for lazy loading

  loadDeletedTrips() {
    this.store.dispatch(actions.LoadDeletedTrips());
  }

  nextDeletedTripsPage() {
    this.store.dispatch(actions.LoadNextPageDeletedTrips());
  }

  loadTripLogs(tripId: number) {
    this.store.dispatch(actions.LoadTripLogs({ tripId }));
  }

  nextTripLogsPage(tripId: number) {
    this.store.dispatch(actions.LoadNextPageTripLogs({ tripId }));
  }

  loadDeletedTripLegs(tripId: number) {
    this.store.dispatch(actions.LoadDeletedTripLegs({ tripId }));
  }

  nextDeletedTripLegsPage(tripId: number) {
    this.store.dispatch(actions.LoadNextPageDeletedTripLegs({ tripId }));
  }

  loadTripLegs(tripId: number) {
    this.store.dispatch(actions.LoadTripLegs({ tripId }));
  }

  nextTripLegsPage(tripId: number) {
    this.store.dispatch(actions.LoadNextPageTripLegs({ tripId }));
  }

  loadLegEventLogs(eventId: number) {
    this.store.dispatch(actions.LoadLegEventLogs({ eventId }));
  }

  nextLegEventLogsPage(eventId: number) {
    this.store.dispatch(actions.LoadNextPageLegEventLogs({ eventId }));
  }

  loadLegFlightLogs(flightId: number) {
    this.store.dispatch(actions.LoadLegFlightLogs({ flightId }));
  }

  nextLegFlightLogsPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageLegFlightLogs({ flightId }));
  }

  loadLegFuelLogs(fuelId: number) {
    this.store.dispatch(actions.LoadLegFuelLogs({ fuelId }));
  }

  nextLegFuelLogsPage(fuelId: number) {
    this.store.dispatch(actions.LoadNextPageLegFuelLogs({ fuelId }));
  }

  loadFlightCrewMembers(flightId: number) {
    this.store.dispatch(actions.LoadFlightCrewMembers({ flightId }));
  }

  nextFlightCrewMembersPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageFlightCrewMembers({ flightId }));
  }

  loadScheduledFlightCrewMembers(flightId: number) {
    this.store.dispatch(actions.LoadScheduledFlightCrewMembers({ flightId }));
  }

  nextScheduledFlightCrewMembersPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageScheduledFlightCrewMembers({ flightId }));
  }

  loadCrewLogs(crewId: number) {
    this.store.dispatch(actions.LoadCrewLogs({ crewId }));
  }

  nextCrewLogsPage(crewId: number) {
    this.store.dispatch(actions.LoadNextPageCrewLogs({ crewId }));
  }

  loadCrewCateringLogs(cateringId: number) {
    this.store.dispatch(actions.LoadCrewCateringLogs({ cateringId }));
  }

  nextCrewCateringLogsPage(cateringId: number) {
    this.store.dispatch(actions.LoadNextPageCrewCateringLogs({ cateringId }));
  }

  loadCrewHotelLogs(hotelId: number) {
    this.store.dispatch(actions.LoadCrewHotelLogs({ hotelId }));
  }

  nextCrewHotelLogsPage(hotelId: number) {
    this.store.dispatch(actions.LoadNextPageCrewHotelLogs({ hotelId }));
  }

  loadCrewTransportationLogs(transportationId: number) {
    this.store.dispatch(actions.LoadCrewTransportationLogs({ transportationId }));
  }

  nextCrewTransportationLogsPage(transportationId: number) {
    this.store.dispatch(actions.LoadNextPageCrewTransportationLogs({ transportationId }));
  }

  loadFlightPassengers(flightId: number) {
    this.store.dispatch(actions.LoadFlightPassengers({ flightId }));
  }

  nextFlightPassengersPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageFlightPassengers({ flightId }));
  }

  loadScheduledFlightPassengers(flightId: number) {
    this.store.dispatch(actions.LoadScheduledFlightPassengers({ flightId }));
  }

  nextScheduledFlightPassengersPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageScheduledFlightPassengers({ flightId }));
  }

  loadPassengerLogs(paxId: number) {
    this.store.dispatch(actions.LoadPassengerLogs({ paxId }));
  }

  nextPassengerLogsPage(paxId: number) {
    this.store.dispatch(actions.LoadNextPagePassengerLogs({ paxId }));
  }

  loadPassengerCateringLogs(cateringId: number) {
    this.store.dispatch(actions.LoadPassengerCateringLogs({ cateringId }));
  }

  nextPassengerCateringLogsPage(cateringId: number) {
    this.store.dispatch(actions.LoadNextPagePassengerCateringLogs({ cateringId }));
  }

  loadPassengerHotelLogs(hotelId: number) {
    this.store.dispatch(actions.LoadPassengerHotelLogs({ hotelId }));
  }

  nextPassengerHotelLogsPage(hotelId: number) {
    this.store.dispatch(actions.LoadNextPagePassengerHotelLogs({ hotelId }));
  }

  loadPassengerTransportationLogs(transportationId: number) {
    this.store.dispatch(actions.LoadPassengerTransportationLogs({ transportationId }));
  }

  nextPassengerTransportationLogsPage(transportationId: number) {
    this.store.dispatch(actions.LoadNextPagePassengerTransportationLogs({ transportationId }));
  }

  // Tier-1: Flight Schedulers
  loadFlightSchedulers(flightId: number) {
    this.store.dispatch(actions.LoadFlightSchedulers({ flightId }));
  }

  nextFlightSchedulersPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageFlightSchedulers({ flightId }));
  }

  loadScheduledFlightSchedulers(flightId: number) {
    this.store.dispatch(actions.LoadScheduledFlightSchedulers({ flightId }));
  }

  nextScheduledFlightSchedulersPage(flightId: number) {
    this.store.dispatch(actions.LoadNextPageScheduledFlightSchedulers({ flightId }));
  }

  // Tier-2: Scheduler Logs
  loadSchedulerLogs(schedulerId: number) {
    this.store.dispatch(actions.LoadSchedulerLogs({ schedulerId }));
  }

  nextSchedulerLogsPage(schedulerId: number) {
    this.store.dispatch(actions.LoadNextPageSchedulerLogs({ schedulerId }));
  }
}
